<template>
  <div class="list-group-item list-group-item-action">
    <div class="list-group">
      <div :style="'margin-left: ' + indent + 'px'">
        <icon v-if="!children.length" :data="bars" class="icon" height="8" width="8"/>
        <icon
            v-else
            :data="listIcon"
            class="icon"
            height="20"
            width="20"
            @click="toggleChildren"
        />
        {{ providerName }}
        <span class="text-subdued" style="margin-right: 10px;">({{ id }})</span>
        <!--        <icon-->
        <!--          @click.stop="handleEditProvider(id)"-->
        <!--          :data="edit"-->
        <!--          width="20"-->
        <!--          height="20"-->
        <!--          role="button"-->
        <!--          class="icon float-right"-->
        <!--        />-->
      </div>
      <div v-if="showChildren">
        <providers-tree
            v-for="child in children"
            :id="child.id"
            :key="child.id"
            :children="child.children"
            :depth="depth + 1"
            :providerName="child.name"
            @edit="handleEditProvider"
        >
        </providers-tree>
      </div>
    </div>
  </div>
</template>
<script>
import bars from "@fa/solid/square.svg";
import listMore from "@fa/solid/angle-right.svg";
import listLess from "@fa/solid/angle-down.svg";
// import edit from "@fa/solid/edit.svg";
export default {
  props: ["providerName", "id", "children", "depth", "parent_id"],
  name: "providers-tree",
  emits: ["edit"],
  data: () => ({
    bars,
    listMore,
    listLess,
    // edit,
    showChildren: false
  }),
  computed: {
    indent() {
      return 10 + this.depth * 50;
    },
    listIcon() {
      return this.showChildren ? listLess : listMore;
    }
  },
  methods: {
    toggleChildren() {
      event.stopPropagation();
      this.showChildren = !this.showChildren;
    },
    selectProvider(id) {
      this.$emit("selected", id);
    },
    handleEditProvider(providerId) {
      this.$emit("edit", providerId);
    }
  }
};
</script>
<style type="text/css">
.icon {
  color: dimgrey;
  margin-right: 10px;
  padding-bottom: 2px;
}
</style>
